// 미리보기 매매금액(원) — 서버가 매매계약서/품의서에 실제로 찍는 값과 동일 규칙.
// 진실 공급원은 utils/pdfTemplates.js 의 pickContractPrice():
//     ① 명의자 송금액이 있으면 그것만            (#262 — 딜러 제외)
//     ② 세금계산서 매입은 계산서 금액(공급가+부가세)만  (Jin 2026-08-11 — 딜러 제외)
//     ③ 그 외/레거시는 매입가(buyPrice) 폴백
// 입력은 모두 '원' 단위 문자열(사용자 입력, 콤마 허용), 반환도 '원' 정수.
// #314 (2026-08-21): 만원 입력이던 것을 원 단위로 전환 — 세금계산서는 1원 단위가 필요하고
//   (만원 소수 2자리 = 100원 한계), 만원 정수 필드는 '421.5' 의 소수점을 조용히 지워
//   4215만원(10배)으로 저장하던 위험이 있었다. 앱은 #179 에서 이미 원 단위로 전환됨.
// 버그 #306: 등록 화면 미리보기가 (명의자+딜러) 만 계산해 ① 세금계산서 매입은 빈칸,
//            ② 개인매입은 딜러 지급액만큼 실물 서류보다 크게 나오던 문제.
// (등록 화면엔 buyPrice 입력이 없어 ③ 폴백은 명의자 미입력 시 딜러 송금액으로 귀결)
var TAX_INVOICE_TYPES = ['business', 'individual_biz_tax'];

// 원 문자열(콤마 허용) → 원 정수.
function toWon(v) {
  var n = parseInt(String(v == null ? '' : v).replace(/[^0-9]/g, ''), 10);
  return isFinite(n) ? n : 0;
}

function previewBuyPriceWon(opts) {
  var o = opts || {};
  var ownerWon = toWon(o.ownerPaymentWon);
  if (ownerWon > 0) return ownerWon;
  if (TAX_INVOICE_TYPES.indexOf(o.purchaseType) >= 0) {
    var tax = toWon(o.supplyAmountWon) + toWon(o.vatAmountWon);
    if (tax > 0) return tax;
  }
  return toWon(o.dealerPaymentWon);
}

// 매입가(원) — 서버가 cars.buyPrice 로 저장하는 값과 동일 규칙.
// 진실 공급원은 routes/cars-mutate.js 의 computedBuyPrice (POST L722-724 / PUT L1049-1053):
//     ① 세금계산서 매입(업체매입/개인사업자 사업용) = 공급가 + 부가세 + 딜러송금
//     ② 그 외 = 명의자송금 + 딜러송금
// ⚠️ previewBuyPriceWon(매매계약서/품의서 금액) 과는 **다른 개념**이다 — 계약서는 명의자 우선 +
//    딜러 제외(#262/#306), 이 함수는 원가라 딜러 송금까지 포함한다. 두 함수를 섞어 쓰지 말 것.
function purchaseCostWon(opts) {
  var o = opts || {};
  var dealerWon = toWon(o.dealerPaymentWon);
  if (TAX_INVOICE_TYPES.indexOf(o.purchaseType) >= 0) {
    return toWon(o.supplyAmountWon) + toWon(o.vatAmountWon) + dealerWon;
  }
  return toWon(o.ownerPaymentWon) + dealerWon;
}

// 인보이스 금액 자동완성 값 — 매입가 + 업체별 마진(companies.invoice_markup, 원).
// 버그 #310 (Jin 결정 2026-08-12): 기준이 '명의자 송금액' 이라 업체매입(세금계산서)·딜러 매입에서는
//   자동완성이 아예 안 돌던 것을 '매입가' 기준으로 통일.
// 반환: null = 자동완성 미개입(사용자가 직접 고쳤거나 외화 인보이스), '' = 비움(매입가 0), 그 외 = 원 단위 문자열.
function autoInvoiceValue(opts) {
  var o = opts || {};
  if (o.manuallyEdited) return null;
  if (o.currency !== 'KRW') return null;
  var costWon = purchaseCostWon(o);
  if (costWon <= 0) return '';
  return String(costWon + (parseInt(o.markupWon) || 0));
}

module.exports = { toWon: toWon, previewBuyPriceWon: previewBuyPriceWon, purchaseCostWon: purchaseCostWon, autoInvoiceValue: autoInvoiceValue };
